<template>
    <div class="product product--list product--list-medium d-flex">


        <div class="product__thumbnail-wrapper">

            <div class="product__thumbnail-wrapper-icon d-flex"
                 v-if="item.allow_autopay">
                <svg width="15" height="17" viewBox="0 0 15 17" fill="none"
                     xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M14.5 10.0389C14.5 9.25158 13.8762 8.62526 13.1139 8.62526C12.8886 8.62526 12.6807 8.67895 12.4901 8.78632C12.2475 8.33895 11.797 8.07053 11.2946 8.07053C11.0693 8.07053 10.8614 8.12421 10.6708 8.23158C10.4282 7.78421 9.97772 7.51579 9.47525 7.51579C9.31931 7.51579 9.16337 7.53368 9.02475 7.58737V6.76421H10.0644C10.896 6.76421 11.5545 6.06632 11.5545 5.20737V1.55684C11.5545 0.697895 10.8787 0 10.0644 0H1.9901C1.15842 0 0.5 0.697895 0.5 1.55684V5.18947C0.5 6.04842 1.17574 6.74632 1.9901 6.74632H6.25247V11.0053L5.68069 10.4147C5.21287 9.93158 4.46782 9.86 3.91337 10.2358C3.58416 10.4684 3.37624 10.8263 3.30693 11.22C3.25495 11.6137 3.35891 12.0253 3.61881 12.3474L6.11386 15.4611C6.89356 16.4453 8.05445 17 9.26733 17H10.8267C11.797 17 12.7153 16.6063 13.4084 15.8905C14.1015 15.1747 14.4827 14.2263 14.4827 13.2242L14.5 10.0389ZM10.8614 16.0337H9.30198C8.34901 16.0337 7.46535 15.6042 6.85891 14.8526L4.36386 11.7389C4.27723 11.6316 4.24257 11.5063 4.2599 11.3632C4.27723 11.22 4.34653 11.1126 4.4505 11.0411C4.5198 10.9874 4.62376 10.9516 4.7104 10.9516C4.83168 10.9516 4.95297 11.0053 5.0396 11.0947L6.04455 12.1326C6.23515 12.3295 6.5297 12.3832 6.7896 12.2758C7.04951 12.1684 7.20544 11.9179 7.20544 11.6316V4.93895C7.20544 4.68842 7.41337 4.47368 7.65594 4.47368C7.77723 4.47368 7.88119 4.52737 7.96782 4.61684C8.05445 4.70632 8.10644 4.81368 8.10644 4.93895V9.5379C8.10644 9.80632 8.31436 10.0211 8.57426 10.0211C8.83416 10.0211 9.04208 9.80632 9.04208 9.5379V8.91158C9.04208 8.66105 9.25 8.44632 9.49257 8.44632C9.73515 8.44632 9.94307 8.66105 9.94307 8.91158V10.1105C9.94307 10.3789 10.151 10.5937 10.4109 10.5937C10.6708 10.5937 10.8787 10.3789 10.8787 10.1105V9.48421C10.8787 9.23368 11.0866 9.01895 11.3292 9.01895C11.5718 9.01895 11.7797 9.23368 11.7797 9.48421V10.6832C11.7797 10.9516 11.9876 11.1663 12.2475 11.1663C12.5074 11.1663 12.7153 10.9516 12.7153 10.6832V10.0568C12.7153 9.80632 12.9233 9.59158 13.1658 9.59158C13.4084 9.59158 13.6163 9.80632 13.6163 10.0568V13.2421C13.6163 13.9937 13.3391 14.6916 12.8193 15.2284C12.2649 15.7474 11.5718 16.0337 10.8614 16.0337ZM1.9901 5.67263C1.7302 5.67263 1.5396 5.45789 1.5396 5.18947V1.55684C1.5396 1.28842 1.74752 1.07368 1.9901 1.07368H10.047C10.3069 1.07368 10.4975 1.28842 10.4975 1.55684V5.18947C10.4975 5.45789 10.2896 5.67263 10.047 5.67263H9.00743V4.95684C9.00743 4.58105 8.86881 4.22316 8.60891 3.95474C8.34901 3.68632 8.00247 3.54316 7.63861 3.54316C6.87624 3.54316 6.2698 4.18737 6.2698 4.97474V5.69053H1.9901V5.67263Z"
                        fill="white"/>
                    <path
                        d="M4.99094 2.32671L4.03797 3.3825L3.70876 3.00671C3.53549 2.80986 3.24094 2.79197 3.05034 2.98881C2.85975 3.16776 2.84242 3.47197 3.03301 3.66881L3.70876 4.42039C3.79539 4.52776 3.91668 4.58144 4.05529 4.58144C4.19391 4.58144 4.31519 4.52776 4.40183 4.42039L5.70133 2.98881C5.8746 2.79197 5.8746 2.48776 5.68401 2.30881C5.49341 2.12986 5.1642 2.12986 4.99094 2.32671Z"
                        fill="white"/>
                </svg>
            </div>

            <catalog-slider type="project" :photos="item.images" :idx="item.id"
                            v-if="media <= 576 && item.images && item.images.length > 1"/>

            <a class="product__thumbnail" :href="'/projects/' + item.id"
               target="_blank" v-else>

                <div v-if="!!item.avatar" class="product__thumbnail-image"
                     :style="'background-image: url(/storage'+ (item.avatar.path.replace('original', 'preview_l')) +')'"></div>
                <div v-else class="product__thumbnail-image"> {{$store.getters.t('catalog_project_no_image')}}</div>

            </a>
        </div>


        <div class="product__details d-flex">
            <div class="product-desc">
                <div class="product_title">
                    <h4><a :href="'/projects/' + item.id"
                           target="_blank">{{ item.name }}</a></h4>
                    <span class="product_title-info d-flex">

                                                <!-- TODO  location & likes -->
                                                <span class="info-block" v-if="item.city"><span
                                                    class="lnr lnr-map-marker"></span> {{ item.city.name }}</span>
                                                <span class="info-block info-block--secondary"><span
                                                    class="lnr lnr-heart"></span> {{ item.followers_count }} {{$store.getters.t('catalog_project_followers')}}</span>

                                            </span>
                </div>
                <p class="product_description">
                    {{ item.ad_title.substring(0, 50).trim() + '...' }} <a
                    :href="'/projects/' + item.id">{{$store.getters.t('catalog_project_read_more')}}</a></p>
                <div class="author d-flex">
                    <div class="author-icon"
                         :class="{'author-icon--loyalty': item.user && item.user.loyalty_level}">
                        <img class="auth-img"
                             :src="'/storage' + item.user.avatar.path.replace('original', 'avatar')"
                             alt="author image" v-if="!!item.user.avatar">
                        <span>{{ getUserPM(item.user.name) }}</span>
                    </div>

                    <p class="v-name">
                        <a target="_blank"
                           :href="'/user/'+ item.user.id +'/profile'">{{ item.user.name }}</a>
                    </p>
                </div>


                <!-- TODO pet labels -->
                <div class="pet-labels d-flex" v-if="item.filters">
                    <div class="pet-labels__item d-flex"
                         v-for="filter in item.filters"
                         :style="{background: filter.color ? filter.color : '#FEF1F1'}">
                        <img :src="`/assets/images/${item.icon}`" alt=""
                             v-if="item.icon">
                        <svg v-else width="15" height="13" viewBox="0 0 15 13"
                             fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                  d="M7.77666 0.545662L14.1914 5.33532C14.3942 5.49546 14.4376 5.78663 14.2783 5.99044C14.1914 6.12147 14.0466 6.1797 13.9018 6.1797C13.8149 6.1797 13.7136 6.15058 13.6267 6.09235L12.7144 5.40811V12.0758C12.7144 12.3378 12.5117 12.5416 12.2511 12.5416H2.73751C2.47686 12.5416 2.27414 12.3378 2.27414 12.0758V5.40811L1.36188 6.09235C1.15916 6.23793 0.869549 6.19426 0.710266 5.99044C0.565463 5.78663 0.608904 5.49546 0.811628 5.33532L7.22641 0.545662C7.38569 0.429197 7.61738 0.429197 7.77666 0.545662ZM6.41551 11.6099H8.58756H9.52878H11.7877V4.70932L7.50153 1.50651L3.21536 4.70932V11.5954H5.47429L6.41551 11.6099Z"
                                  fill="#91DA66"/>
                            <path
                                d="M7.50112 4.54747C6.94563 4.5475 6.40266 4.71313 5.94087 5.02335C5.47904 5.3336 5.11916 5.77451 4.90667 6.29027C4.69418 6.80602 4.63859 7.37351 4.74691 7.92099C4.85523 8.46848 5.12261 8.97146 5.51532 9.36628C5.90804 9.76111 6.40846 10.0301 6.95333 10.139C7.4982 10.248 8.06296 10.1921 8.57618 9.97833C9.0894 9.7646 9.52797 9.40271 9.83649 8.93849C10.145 8.47428 10.3096 7.92857 10.3096 7.37037V7.27037H10.2096H9.88464H9.78464V7.37037C9.78464 7.82463 9.65066 8.26864 9.39969 8.64626C9.14873 9.02387 8.79209 9.3181 8.37492 9.49182C7.95777 9.66554 7.49877 9.71099 7.05595 9.62243C6.61313 9.53388 6.2063 9.31528 5.88693 8.99419C5.56756 8.6731 5.35001 8.26395 5.26186 7.81843C5.17372 7.37292 5.21896 6.91113 5.39185 6.4915C5.56474 6.07187 5.85747 5.71329 6.23296 5.46105C6.60844 5.20881 7.04982 5.07421 7.50131 5.07421L7.50172 5.07421C7.805 5.07297 8.10544 5.13312 8.38514 5.25111C8.5163 5.30643 8.64439 5.40095 8.76976 5.51383C8.83562 5.57312 8.89895 5.6358 8.96053 5.69876H8.46197C8.34615 5.69876 8.25226 5.79265 8.25226 5.90847C8.25226 6.02429 8.34615 6.11818 8.46197 6.11818H9.45884C9.62453 6.11818 9.75884 5.98386 9.75884 5.81818V4.78872C9.75884 4.65546 9.6508 4.54743 9.51754 4.54745C9.3843 4.54746 9.2763 4.65548 9.2763 4.78872V5.25705C8.78229 4.83138 8.16194 4.54507 7.50112 4.54747ZM7.50112 4.54747C7.50118 4.54747 7.50124 4.54746 7.50131 4.54746V4.64746L7.50093 4.54747C7.501 4.54747 7.50106 4.54747 7.50112 4.54747Z"
                                fill="#91DA66" stroke="#91DA66" stroke-width="0.2"/>
                            <path
                                d="M7.45195 6.48565C7.45195 6.3959 7.3792 6.32315 7.28945 6.32315V6.32315C7.19971 6.32315 7.12695 6.3959 7.12695 6.48565V7.64371C7.12695 7.70184 7.15224 7.75709 7.19623 7.79508L8.09388 8.5703C8.16226 8.62935 8.26562 8.62152 8.32432 8.55284V8.55284C8.38259 8.48467 8.37484 8.38223 8.30697 8.3236L7.45195 7.58495V6.48565Z"
                                fill="#91DA66" stroke="#91DA66" stroke-width="0.6"/>
                        </svg>
                    </div>
                </div>


            </div>
            <!-- end /.product-desc -->


            <div class="product-purchase d-flex" v-if="item.need_sum > 0">

                <div class="sum_info d-flex">
                    <span>{{ item.donations_total ? parseInt(item.donations_total).toFixed() : 0 }} EUR</span>
                    <span
                        class="sum_info--secondary">{{ parseInt(item.need_sum).toFixed() }} EUR</span>
                </div>

                <div class="pet-progress progress">
                    <div class="progress-bar" role="progressbar"
                         :aria-valuenow="item.donations_progress" aria-valuemin="0"
                         aria-valuemax="100"
                         :style="'width:' + (item.donations_progress > 100 ? 100 : parseInt(item.donations_progress).toFixed()) +'%;'">
                                                        <span v-if="item.donations_total > 0">{{
                                                                parseInt(item.donations_progress).toFixed()
                                                            }}%</span>
                    </div>
                </div>

                <div class="labels clearfix d-flex">
                    <span class="already-have-money">{{$store.getters.t('catalog_project_collected')}}</span>
                    <span class="already-have-money">{{$store.getters.t('catalog_project_goal')}}</span>
                </div>

                <a :href="'/projects/' + item.id" target="_blank"
                   class="btn btn-sm btn--round">
                    {{$store.getters.t('catalog_project_help')}}
                </a>

            </div>
            <div class="product-purchase product-purchase--center d-flex" v-else>

                <a :href="'/projects/' + item.id" target="_blank"
                   class="btn btn-sm btn--round">
                    {{$store.getters.t('catalog_project_meet')}}
                </a>

            </div>
            <!-- end /.product-purchase -->


        </div>
    </div>

</template>

<script>

import CatalogSlider from "./CatalogSlider";

export default {
    name: "CatalogProject",
    components: { CatalogSlider },
    props: ['item'],
    data(){
        return{
            media: 0,
        }
    },

    created() {
        window.addEventListener("resize", this.myEventHandler);
    },
    destroyed() {
        window.removeEventListener("resize", this.myEventHandler);
    },

    mounted(){
        this.myEventHandler();
    },

    methods:{
        myEventHandler(e) {
            this.media = window.innerWidth
        },
        getUserPM(name) {
            if (!name) {
                return '';
            }
            let nameArray = name.trim().split(' ');
            return nameArray[0][0] + ((nameArray[1]) ? nameArray[1][0] : '') + '';
        },

    }
}
</script>

<style lang="scss" scoped>

.product:hover .product__thumbnail:before{
    display: none;
}


</style>
